
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student/student-dashboard",
      function () {
        return require("private-next-pages/student/student-dashboard/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student/student-dashboard"])
      });
    }
  